import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeedbackService } from '@nk/core/services/feedback.service';
import { AppService } from '@nk/access-block';
import { AppIdentityCompositeEntity } from '@nk/data-entities-lib';

import { BsModalRef } from 'ngx-bootstrap/modal';
import { NkToastrService } from '@nk/ui-lib';

@Component({
  selector: 'nk-general-feedback',
  templateUrl: './general-feedback.component.html',
  standalone: false,
})
export class GeneralFeedbackComponent implements OnInit, OnDestroy {
  public identity: AppIdentityCompositeEntity;
  public message: string;

  constructor(
    public bsModalRef: BsModalRef,
    private _appService: AppService,
    private _feedbackService: FeedbackService,
    private _toastr: NkToastrService,
  ) {}

  public ngOnInit(): void {
    this._appService.identityDataCache.get().subscribe((identity) => (this.identity = identity));
  }

  public sendFeedback(): void {
    this._feedbackService.submitFeedback(this.message, 'general_feedback').subscribe(
      (feedback) => {
        this._toastr.success('Thank you for your feedback. If necessary, we will get back to you as soon as possible.');
        this.bsModalRef.hide();
      },
      (error) => {
        this._toastr.error(
          'Your message was never sent. Please try again. If the problem persists, please contact us.',
          'Something unexpected happened',
        );
      },
    );
  }

  public ngOnDestroy(): void {}
}
